import { defineMessages } from 'react-intl';

export default defineMessages({
  askPasscodeMsg: {
    defaultMessage: 'Ask your group leader for the passcode to be able to send your order to the kitchen.',
  },
});
